import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import Locale from 'localization/Localization';

export class PublicHomePage extends React.Component<RouteComponentProps<{}>, {}>
{
	public componentDidMount()
	{
		document.title = Locale.get('home_title');
	}

    public render() {
		return <Redirect to='/login' />
		// return (
		// 	<PublicLayout>
		// 		<div className='splash-bg'>
		// 			<div className='splash'>
        //                 <div className='splash-container'>
        //                     <img className='home-logo' src='/assets/images/site-logo-192.png' />
        //                     <h2>{L.get('home_title')}</h2>
		// 				</div>
		// 			</div>
		// 		</div>
		// 	</PublicLayout>
		// );
    }
}
